import { ITabStructure } from '../../../../../types/ITabStructure'

export const appointmentFormTabs: ITabStructure[] = [
  {
    title: 'Appointment',
    value: 'create_appointment',
    icon: 'calendar-circle-plus',
  },
  { title: 'Last minute', value: 'create_lastMinutes', icon: 'calendar-clock' },
  { title: 'Block', value: 'create_block', icon: 'calendar-circle-minus' },
]
